import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from "@angular/core";
import { SecEventsService } from "../expandable/sec-events.service";
import { SecEventType } from "../../../domain/sec-events";

@Component({
  selector: "evrideo-calendar-filter-sec-events",
  templateUrl: "./calendar-filter-sec-events.component.html",
  styleUrls: ["./calendar-filter-sec-events.component.scss"],
})
export class CalendarFilterSecEventsComponent {
  active = false;

  secEventType = SecEventType;

  selectedFilters: Set<SecEventType> =
    this.secEventsService.onFilterSecEvents.value;

  constructor(
    private secEventsService: SecEventsService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {}

  show(): void {
    this.active = true;
    this.changeDetectorRef.detectChanges();
  }

  hide(): void {
    this.active = false;
    this.changeDetectorRef.detectChanges();
  }

  toggle(): void {
    this.active = !this.active;
    this.changeDetectorRef.detectChanges();
  }

  itemClicked(input) {
    if (input === "clearAll") {
      this.selectedFilters.clear();
    } else if (this.selectedFilters.has(input)) {
      this.selectedFilters.delete(input);
    } else {
      this.selectedFilters.add(input);
    }

    this.secEventsService.onFilterSecEvents.next(this.selectedFilters);
  }
}
